<template>
    <vx-card :title='$t("Multiplier")' collapse-action>
        <div class="mt-6">
            <vs-table v-model="selected" @selected="handleSelected" :data="multipliers">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div class="flex flex-wrap-reverse items-center mb-3">
                        <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addMultiplierPrompt = true">{{$t("Add")}}</vs-button>
                    </div>

                </div>

                <template slot="thead">
                    <vs-th>{{$t("Multiplier")}}</vs-th>
                    <vs-th>{{$t("Priority")}}</vs-th>
                    <vs-th>{{$t("StartTime")}}</vs-th>
                    <vs-th>{{$t("EndTime")}}</vs-th>
                    <vs-th>{{$t("Holidays")}}</vs-th>
                    <vs-th>{{$t("Days")}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                        <vs-td :data="data[indextr].multiplier">
                            {{data[indextr].multiplier}}
                        </vs-td>

                        <vs-td :data="data[indextr].priority">
                            {{data[indextr].priority}}
                        </vs-td>

                        <vs-td :data="data[indextr].hours_from + ':' + data[indextr].minutes_from + ':' + data[indextr].seconds_from">
                            {{data[indextr].hours_from + ':' + data[indextr].minutes_from + ':' + data[indextr].seconds_from}}
                        </vs-td>

                        <vs-td :data="data[indextr].hours_to + ':' + data[indextr].minutes_to + ':' + data[indextr].seconds_to">
                            {{data[indextr].hours_to + ':' + data[indextr].minutes_to + ':' + data[indextr].seconds_to}}
                        </vs-td>

                        <vs-td :data="data[indextr].holidays">
                            {{(data[indextr].holidays) ? $t("Yes") : $t("No")}}
                        </vs-td>

                        <vs-td :data="data[indextr].week_days">
                            {{weekDaysToText(data[indextr].week_days)}}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :title="$t('Add')" :active.sync="addMultiplierPrompt">
            <div>
                <p class="mt-6">{{$t("Multiplier")}}</p>
                <vs-input v-model="multiplierAdd['multiplier']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Priority")}}</p>
                <vs-input v-model="multiplierAdd['priority']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("StartTime")}}</p>
                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="multiplierAdd['startTime']" />
                <p class="mt-6">{{$t("EndTime")}}</p>
                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="multiplierAdd['endTime']" />
                <p class="mt-6">{{$t("Days")}}</p>
                <vs-select autocomplete multiple class="selectExample w-full" v-model="selectedAddDays">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in [{value: 1, text: this.$t('Monday')}, {value: 2, text: this.$t('Tuesday')}, {value: 3, text: this.$t('Wednesday')}, {value: 4, text: this.$t('Thursday')}, {value: 5, text: this.$t('Friday')}, {value: 6, text: this.$t('Saturday')}, {value: 0, text: this.$t('Sunday')}]" />
                </vs-select>
                <vs-checkbox class="mt-6" v-model="multiplierAdd['holidays']">{{$t("Holidays")}}</vs-checkbox>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addMultiplier">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editMultiplierPrompt">
            <div>
                <p class="mt-6">{{$t("Multiplier")}}</p>
                <vs-input v-model="multiplierEdit['multiplier']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Priority")}}</p>
                <vs-input v-model="multiplierEdit['priority']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("StartTime")}}</p>
                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="multiplierEdit['startTime']" />
                <p class="mt-6">{{$t("EndTime")}}</p>
                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="multiplierEdit['endTime']" />
                <p class="mt-6">{{$t("Days")}}</p>
                <vs-select autocomplete multiple class="selectExample w-full" v-model="selectedEditDays">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in [{value: 1, text: this.$t('Monday')}, {value: 2, text: this.$t('Tuesday')}, {value: 3, text: this.$t('Wednesday')}, {value: 4, text: this.$t('Thursday')}, {value: 5, text: this.$t('Friday')}, {value: 6, text: this.$t('Saturday')}, {value: 0, text: this.$t('Sunday')}]" />
                </vs-select>
                <vs-checkbox class="mt-6" v-model="multiplierEdit['holidays']">{{$t("Holidays")}}</vs-checkbox>
                <vs-divider/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editMultiplier">{{$t("Save")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeMultiplier">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>

    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr,
        },
        data() {
            return {

                multipliers: [],
                addMultiplierPrompt: false,
                multiplierAdd: {},
                selectedAddDays: [],

                editMultiplierPrompt: false,
                multiplierEdit: {},
                selected: {},
                selectedEditDays: [],

                configdateTimePicker: {
                    enableTime: true,
                    enableSeconds: true,
                    noCalendar: true,
                    time_24hr: true,
                    minuteIncrement: 1
                }

            }
        },
        watch: {
            editMultiplierPrompt: function () {
                if(!this.editMultiplierPrompt){
                    this.selected = {}
                }
            }
        },
        methods: {
            handleSelected(tr) {
                this.multiplierEdit = Object.assign({}, tr);
                this.multiplierEdit.startTime = this.multiplierEdit.hours_from + ":" + this.multiplierEdit.minutes_from + ":" + this.multiplierEdit.seconds_from;
                this.multiplierEdit.endTime = this.multiplierEdit.hours_to + ":" + this.multiplierEdit.minutes_to + ":" + this.multiplierEdit.seconds_to;
                this.selectedEditDays = [...tr.week_days];
                this.editMultiplierPrompt = true;
            },
            isPromptOpen() {
                return this.addMultiplierPrompt || this.editMultiplierPrompt;
            },
            closePrompts(){
                this.addMultiplierPrompt = false;
                this.editMultiplierPrompt = false;
            },
            updateMultipliers() {
                const thisIns = this;
                this.$http.get('/api/v1/settings/multiplier')
                    .then(function (response) {
                        thisIns.multipliers = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addMultiplier() {

                let startTimes = this.multiplierAdd.startTime.split(":");
                let endTimes = this.multiplierAdd.endTime.split(":");

                this.multiplierAdd.hours_from = Number(startTimes[0]);
                this.multiplierAdd.minutes_from = Number(startTimes[1]);
                this.multiplierAdd.seconds_from = Number(startTimes[2]);

                this.multiplierAdd.hours_to = Number(endTimes[0]);
                this.multiplierAdd.minutes_to = Number(endTimes[1]);
                this.multiplierAdd.seconds_to = Number(endTimes[2]);

                this.multiplierAdd.multiplier = Number(this.multiplierAdd.multiplier);
                this.multiplierAdd.priority = Number(this.multiplierAdd.priority);

                this.multiplierAdd.week_days = this.selectedAddDays;

                const thisIns = this;
                this.$http.post('/api/v1/settings/multiplier', this.multiplierAdd)
                .then(function () {
                    thisIns.updateMultipliers();
                    thisIns.addMultiplierPrompt = false;
                    thisIns.multiplierAdd = {};
                }).catch(function (error) {
                    thisIns.addMultiplierPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editMultiplier(){

                let startTimes = this.multiplierEdit.startTime.split(":");
                let endTimes = this.multiplierEdit.endTime.split(":");

                this.multiplierEdit.hours_from = Number(startTimes[0]);
                this.multiplierEdit.minutes_from = Number(startTimes[1]);
                this.multiplierEdit.seconds_from = Number(startTimes[2]);

                this.multiplierEdit.hours_to = Number(endTimes[0]);
                this.multiplierEdit.minutes_to = Number(endTimes[1]);
                this.multiplierEdit.seconds_to = Number(endTimes[2]);

                this.multiplierEdit.multiplier = Number(this.multiplierEdit.multiplier);
                this.multiplierEdit.priority = Number(this.multiplierEdit.priority);

                this.multiplierEdit.week_days = [...this.selectedEditDays];

                const thisIns = this;
                this.$http.put('/api/v1/settings/multiplier/' + this.selected.id, this.multiplierEdit)
                    .then(function () {
                        thisIns.updateMultipliers();
                        thisIns.editMultiplierPrompt = false;
                    }).catch(function (error) {
                    thisIns.editMultiplierPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeMultiplier(){
                const thisIns = this;
                this.$http.delete('/api/v1/settings/multiplier/' + this.selected.id)
                    .then(function () {
                        thisIns.updateMultipliers();
                        thisIns.editMultiplierPrompt = false;
                    }).catch(function (error) {
                    thisIns.editMultiplierPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            dayToText(day){
              switch(day) {
                  case 0: return this.$t("Sunday");
                  case 1: return this.$t("Monday");
                  case 2: return this.$t("Tuesday");
                  case 3: return this.$t("Wednesday");
                  case 4: return this.$t("Thursday");
                  case 5: return this.$t("Friday");
                  case 6: return this.$t("Saturday");
              }
            },
            weekDaysToText(days){

                let text = "";
                for(let x = 0; x < days.length; x++){
                    text += this.dayToText(days[x]) + ", ";
                }

                if(text.length > 0) {
                    text = text.substring(0, text.length - 2);
                }

                return text;
            }
        },
        created() {
            this.updateMultipliers();
            this.multiplierAdd['startTime'] = null;
            this.multiplierAdd['endTime'] = null;
            this.multiplierAdd['week_days'] = [];
        },
    }

</script>
